export enum PropertyType {
    ALL = 0,
    HOUSE = 1,
    APARTMENT = 2
}
